import {Controller, Form, FormProvider, useController, useFieldArray, useForm, useFormContext, useFormState, useWatch} from "react-hook-form";

/**
 * Import workarounds (webpack causes issues with current monorepo config, need to import hooks from this package
 * instead directly from lib)
 */
/**
 * @deprecated use util from package `@pg-mono/react-hook-forms-utils`
 */
export const useFormRHF = useForm;
/**
 * @deprecated use util from package `@pg-mono/react-hook-forms-utils`
 */
export const FormRHF = Form;
/**
 * @deprecated use util from package `@pg-mono/react-hook-forms-utils`
 */
export const useControllerRHF = useController;
/**
 * @deprecated use util from package `@pg-mono/react-hook-forms-utils`
 */
export const ControllerRHF = Controller;
/**
 * @deprecated use util from package `@pg-mono/react-hook-forms-utils`
 */
export const useFormContextRHF = useFormContext;
/**
 * @deprecated use util from package `@pg-mono/react-hook-forms-utils`
 */
export const FormProviderRHF = FormProvider;
/**
 * @deprecated use util from package `@pg-mono/react-hook-forms-utils`
 */
export const useWatchRHF = useWatch;
/**
 * @deprecated use util from package `@pg-mono/react-hook-forms-utils`
 */
export const useFormStateRHF = useFormState;
/**
 * @deprecated use util from package `@pg-mono/react-hook-forms-utils`
 */
export const useFieldArrayRHF = useFieldArray;
import {Controller, Form, FormProvider, useController, useFieldArray, useForm, useFormContext, useFormState, useWatch} from "react-hook-form";

/**
 * Import workarounds (webpack causes issues with current monorepo config, need to import hooks from this package
 * instead directly from lib)
 */
/**
 * @deprecated use util from package `@pg-mono/react-hook-forms-utils`
 */
export const useFormRHF = useForm;
/**
 * @deprecated use util from package `@pg-mono/react-hook-forms-utils`
 */
export const FormRHF = Form;
/**
 * @deprecated use util from package `@pg-mono/react-hook-forms-utils`
 */
export const useControllerRHF = useController;
/**
 * @deprecated use util from package `@pg-mono/react-hook-forms-utils`
 */
export const ControllerRHF = Controller;
/**
 * @deprecated use util from package `@pg-mono/react-hook-forms-utils`
 */
export const useFormContextRHF = useFormContext;
/**
 * @deprecated use util from package `@pg-mono/react-hook-forms-utils`
 */
export const FormProviderRHF = FormProvider;
/**
 * @deprecated use util from package `@pg-mono/react-hook-forms-utils`
 */
export const useWatchRHF = useWatch;
/**
 * @deprecated use util from package `@pg-mono/react-hook-forms-utils`
 */
export const useFormStateRHF = useFormState;
/**
 * @deprecated use util from package `@pg-mono/react-hook-forms-utils`
 */
export const useFieldArrayRHF = useFieldArray;
